import React from "react";
import { size } from "lodash";
import DropdownList from "@komon/dropdown/list";
import NavbarDropdown from "@komon/navigation/navbar/dropdown";
import Icon from "@ui-kit/icon";

interface Feature {
  id: string;
  label: string;
  icon: string;
  url?: string;
  error?: boolean;
}

interface IProps {
  openFeature: (feature: string) => void;
  pullRight?: boolean;
  features: Feature[];
}

const NavigationNavbarFeatures = ({
  openFeature,
  pullRight,
  features,
}: IProps) => {
  return (
    !!size(features) && (
      <NavbarDropdown
        toggle={<Icon glyph="dots-3-v" size="s" />}
        pullRight={pullRight}
        menu={
          <DropdownList
            items={features}
            onClick={(feature) => openFeature(feature.id as string)}
            pullRight={pullRight}
          />
        }
      />
    )
  );
};

export default NavigationNavbarFeatures;
